import { createRouter, createWebHashHistory } from "vue-router";
import Builder from "../views/Builder.vue";

const routes = [
  {
    path: "/",
    name: "Builder",
    component: Builder,
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router;
